import { addGroup, groupInit, removeGroup, saveOrderGroup, updateGroupAttribute } from "features/library/reducer/LibraryActions";
import { currentWorkspaceId } from "index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { findWorkspaceById } from "redux/memoizedSelectors";
import DataLoader from "shared/components/data-loader";
import DragDrop, { SetItemsProps } from "shared/Drag-Drop/DragDrop";
import { CustomBreadCrumb } from "shared/ui-basics/ui-components/CustomBreadCrumb";
import TaxonomyCreateItem from "../components/TaxonomyCreateItem";
import TaxonomyListItem from "../components/TaxonomyListItem";
import { Body, Container, Header, RecordsContainer, Wrapper } from "./style";

const TaxonomyGroup: React.FC = () => {
	const { t } = useTranslation();

	const currentWorkspace = useSelector(findWorkspaceById(currentWorkspaceId));
	const groups = useSelector((state: any) => state.libraries.group);

	const onCreate = ({ name }: { name: string }) => addGroup({ newGroup: { name:name?.truncate(100,true), colorCode: "#64748B" } });

	const onUpdate = ({ updatedItem, modifiedAttribNames }: { updatedItem: any; modifiedAttribNames: string[] }) => updateGroupAttribute({ modifiedGroup: updatedItem, modifiedAttribNames });

	const onDelete = ({ item }: { item: any }) => removeGroup({ id: item.id });

	const onDragEnd = ({ newItems }: SetItemsProps) => saveOrderGroup({ ids: newItems?.map((el) => el.id)?.join("|") });

	const defaultColor = { color: "#1e293b", backgroundColor: "#f3f4f6" };

	return (
		<DataLoader reduxActions={[groupInit]}>
			<Container>
				<Header>
					<CustomBreadCrumb paths={[currentWorkspace?.name, t("TAXONOMY"), t("GROUP")]} />
				</Header>
				<Body>
					<Wrapper>
						<div className="f24-title mb-4">{t("GROUP")}</div>
						<TaxonomyCreateItem onCreate={onCreate} />
						<RecordsContainer>
							<DragDrop items={groups} setItems={onDragEnd} orientation="vertical">
								{(item) => <TaxonomyListItem key={item.id} item={item} onUpdate={onUpdate} onDelete={onDelete} defaultColor={defaultColor} />}
							</DragDrop>
						</RecordsContainer>
					</Wrapper>
				</Body>
			</Container>
		</DataLoader>
	);
};

export default TaxonomyGroup;
